import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getDiscomByState,
  getLccEnergyType,
  getLccStateAndUt,
  getLccSubmit,
  getUserLCC,
} from "../../Services/ApiCalling/Lcc";

export const userLcc = createAsyncThunk(
  "lcc/getUserLCC",
  async ({ token, type }) => {
    try {
      let data = await getUserLCC(token, type);
      return { user: data };
    } catch (err) {}
  }
);

export const LccStateandUt = createAsyncThunk(
  "lcc/getLccStateAndUt",
  async ({ token }) => {
    try {
      let data = await getLccStateAndUt(token);
      
      return { user: data };
    } catch (err) {}
  }
);

export const discomByState = createAsyncThunk(
  "lcc/getDiscomByState", 
  async ({ token, stateId },  { rejectWithValue }) => {
    try {
      let data = await getDiscomByState(token, stateId);
      
      return { user: data }; 
    } catch (err) {
      
      return rejectWithValue(err.response?.data || "Failed to fetch discoms");
    }
  }
);

export const LccEnergyType = createAsyncThunk(
  "lcc/getLccEnergyType",
  async ({ token }) => {
    try {
      let data = await getLccEnergyType(token);
      return { user: data };
    } catch (err) {}
  }
);

export const lccSubmit = createAsyncThunk(
  "lcc/lccSubmit",
  async ({ token, payload }, { rejectWithValue }) => {
    try {
      let data = await getLccSubmit(token, payload);
      return { response: data };
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to submit LCC data");
    }
  }
);


const initialState = {
  discomByState: null, 
  LccStateandUt: [],
  LccEnergyType: [],
  userLcc: [],
  lccSubmitResponse: null,
  loading: false,
  error: null,
};


const lccSlice = createSlice({
  name: "lcc",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(userLcc.fulfilled, (state, action) => {
        state.userLcc = action.payload?.user?.data?.data;
      })
      .addCase(LccStateandUt.fulfilled, (state, action) => {
        state.LccStateandUt = action.payload?.user?.data?.data;
      })
      .addCase(LccEnergyType.fulfilled, (state, action) => {
        state.LccEnergyType = action.payload?.user?.data?.data;
      })
      .addCase(discomByState.pending, (state) => {
        state.loading = true;
      })
      .addCase(discomByState.fulfilled, (state, action) => {
        state.loading = false;
        state.discomByState = action.payload?.user?.data?.data || []; 
      })
      .addCase(discomByState.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })
      .addCase(lccSubmit.pending, (state) => {
        state.loading = true;
      })
      .addCase(lccSubmit.fulfilled, (state, action) => {
        state.loading = false;
        state.lccSubmitResponse = action.payload?.response?.data;
      })
      .addCase(lccSubmit.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "LCC submission failed";
      });
  },
});


export const { setConsumerDetails } = lccSlice.actions;
export const { setPoint } = lccSlice.actions;

export default lccSlice.reducer;
